import { memo, useState } from 'react';
import { useFetchHasCampaigns } from 'universal-associations-select/hooks/useFetchHasCampaigns';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIResultsMessage from 'UIComponents/results/UIResultsMessage';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import UIButton from 'UIComponents/button/UIButton';
import { Button } from 'foundations-components/transitional/components/Button';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { Small } from 'foundations-components/transitional/components/Small';
import PortalIdParser from 'PortalIdParser';
import { RefreshIcon } from 'foundations-assets';
import CrmLogger from 'customer-data-tracking/loggers/CrmLogger';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const CampaignsEmptyState = ({
  refetchOptions,
  engagementOrInteractionType
}) => {
  const {
    data,
    loading
  } = useFetchHasCampaigns();
  const [hasClickedCreateCampaign, setHasClickedCreateCampaign] = useState(false);
  if (loading || !data) {
    return /*#__PURE__*/_jsx(LoadingSpinner, {
      grow: true,
      marginBlockStart: "400"
    });
  }
  if (data.hasCampaigns) {
    return /*#__PURE__*/_jsxs(UIResultsMessage, {
      className: "m-top-2 m-bottom-0",
      illustration: "empty-state-charts",
      illustrationProps: {
        width: 130,
        className: 'm-bottom-4'
      },
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: 'universalAssociationsSelect.searchResults.noResults.noRecordsFound'
      }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(FormattedMessage, {
        message: "universalAssociationsSelect.searchResults.noResults.searchToFind"
      })]
    });
  }
  return /*#__PURE__*/_jsx(UIResultsMessage, {
    className: "m-top-2 m-bottom-0",
    illustration: "campaigns",
    illustrationProps: {
      width: hasClickedCreateCampaign ? 60 : 80,
      className: 'm-bottom-3'
    },
    children: /*#__PURE__*/_jsxs(TFlex, {
      direction: "column",
      align: "center",
      children: [/*#__PURE__*/_jsx(Small, {
        children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
          message: "universalAssociationsSelect.searchResults.campaigns.title_jsx",
          options: {
            className: 'p-all-0',
            style: {
              marginTop: '-2px',
              fontSize: '12px'
            },
            href: 'https://knowledge.hubspot.com/campaigns/understand-campaigns',
            use: 'link',
            external: true
          },
          elements: {
            Button: UIButton
          }
        })
      }), /*#__PURE__*/_jsx(Button, {
        use: "primary",
        size: "small",
        onClick: () => {
          setHasClickedCreateCampaign(true);
          CrmLogger.log('universalAssociationsSelect', {
            action: 'create campaign',
            toObjectTypeId: '0-35',
            engagementOrInteractionType,
            location: 'campaigns association empty state',
            pluralObjectName: 'Campaigns',
            subjectObjectTypeId: '0-35'
          });
        },
        href: `/marketing/${PortalIdParser.get()}/campaigns`,
        external: true,
        marginBlockStart: "200",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "universalAssociationsSelect.searchResults.campaigns.createButton"
        })
      }), hasClickedCreateCampaign && /*#__PURE__*/_jsxs(Button, {
        use: "link",
        size: "small",
        onClick: refetchOptions,
        marginBlockStart: "200",
        children: [/*#__PURE__*/_jsx(RefreshIcon, {}), /*#__PURE__*/_jsx(FormattedMessage, {
          message: "universalAssociationsSelect.searchResults.campaigns.refreshButton"
        })]
      })]
    })
  });
};
export default /*#__PURE__*/memo(CampaignsEmptyState);